var map = {
	"./1/top-left-1.png": "yBv+",
	"./2/top-left-1.png": "iTnh",
	"./3/top-left-1.png": "P7WW",
	"./4/top-left-1.png": "vVQ+",
	"./5/top-left-1.png": "kcBv",
	"./6/top-left-1.png": "UQMD",
	"./7/top-left-1.png": "tp/7",
	"./8/top-left-1.png": "UQdw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Jji";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/top\-left\-1\.png$
// module id = 8Jji
// module chunks = 1